<template>
  <div class="page-header-main">
    <div class="page-header navbar navbar-fixed-top">
      <div class="page-header-inner ">
        <div class="page-logo" style="width: 133px">
          <router-link to="/admin/dashboard">
            <img src="/static/layouts/layout2/img/logo-default.png" alt="logo" class="logo-default"/>
          </router-link>
          <div class="menu-toggler sidebar-toggler">
            <!-- DOC: Remove the above "hide" to enable the sidebar toggler button on header -->
          </div>
        </div>
        <a href="javascript:;" class="menu-toggler responsive-toggler" data-toggle="collapse"
           data-target=".navbar-collapse"> </a>
        <div class="page-actions">
          <div class="btn-group">&nbsp;&nbsp;</div>
        </div>

        <div class="page-top">
          <autocomplete :selection.sync="value"
                        v-on:searchQuery="displaySearchQuery"
                        v-on:openSearchModal="openSearchModal"
                        v-if="user.access > 1"/>
          <div class="top-menu">
            <ul class="nav navbar-nav pull-right">
              <!-- DOC: Apply "dropdown-dark" class after below "dropdown-extended" to change the dropdown styte -->
              <inbox v-if="showMessages"
                     :user="user"/>
              <!-- BEGIN USER LOGIN DROPDOWN -->
              <!-- DOC: Apply "dropdown-dark" class after below "dropdown-extended" to change the dropdown styte -->
              <li class="dropdown dropdown-user">
                <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown"
                   data-close-others="true">
                  <!--<img v-bind:src="avatar" class="img-circle">-->
                  <avatar v-bind:username="name" v-bind:src="avatar" :size="40" :rounded="true" color="#d09f23"
                          backgroundColor="#eef1f5"></avatar>
                  <em class="fa fa-angle-down"></em>
                </a>
                <ul class="dropdown-menu dropdown-menu-default">
                  <li>
                    <a href="" v-if="user.access > 1" @click.prevent="showProfileModal">
                      <i class="icon-user"></i> My Profile
                    </a>
                  </li>
                  <li v-if="false">
                    <a href="#.html">
                      <i class="icon-envelope-open"></i> Email Settings
                      <!--     <span class="badge badge-danger"> 3 </span>-->
                    </a>
                  </li>
                  <li v-if="user.access > 1">
                    <a href="" @click.prevent="showTimeZoneModal">
                      <i class="icon-clock"></i> Time Zone Settings
                    </a>
                  </li>
                  <li class="divider"></li>
                  <li>
                    <a @click="logoutMe">
                      <i class="icon-lock"></i> Log Out </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <!-- END TOP NAVIGATION MENU -->
        </div>
      </div>
    </div>
    <search-modal :query="searchValue" :refreshSearch="refreshSearch"/>
    <my-profile v-on:avatarUpdate="updateAvatar"/>
    <user-profile v-on:avatarUpdate="updateAvatar"/>
    <time-zone/>
  </div>
</template>

<script>
  import {getUserInfo} from '@/http-common';
  import Avatar from '@/components/menu/Avatar.vue';
  import Inbox from './Inbox.vue';
  import Autocomplete from '@/components/search/Autocomplete.vue';
  import SearchModal from '@/components/search/SearchModal.vue';
  import MyProfile from '@/components/modals/MyProfile.vue';
  import UserProfile from '@/components/modals/UserProfile.vue';
  import TimeZone from '@/components/modals/TimeZone.vue';
  import {mapGetters} from 'vuex';

  export default {

    name: 'page-header',

    data() {
      return {
        msg: 'Header',
        value: '',
        name: getUserInfo('first_name'),
        avatar: getUserInfo('avatar') ? getUserInfo('avatar') : undefined,
        searchValue: '',
        refreshSearch: false
      }
    },

    components: {
      Autocomplete,
      SearchModal,
      MyProfile,
      TimeZone,
      Avatar,
      Inbox,
      UserProfile,
    },

    computed: {
      ...mapGetters({
        user: 'getUser'
      }),
      showMessages() {
        return this.user.access > 2; // && twilio.status
      }
    },

    methods: {
      displaySearchQuery: function (id) {
        this.searchValue = id;
      },

      logoutMe() {
        this.$parent.$options.methods.logout();
      },

      openSearchModal() {
        this.refreshSearch = !this.refreshSearch;
        $('#search_modal').modal('show');
      },

      showProfileModal() {
        $('#profile_modal').modal('show');
      },

      showTimeZoneModal() {
        $('#timezone_modal').modal('show');
      },

      updateAvatar() {
        this.avatar = getUserInfo('avatar') ? getUserInfo('avatar') : undefined;
      },
    }
  }
</script>
<style>
  .avatar-fa {
    width: 40px;
    height: 40px;
    display: inline-block;
    background-color: #eef1f5;
    border-radius: 50% !important;
    color: #d09f23;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
  }

  .avatar-placeholder {
    width: 40px;
    height: 40px;
    margin-top: -8px;
    margin-right: 7px;
    display: inline-block;
    background-color: #eef1f5;
    border: 1px solid transparent;
    border-radius: 50% !important;
  }

  .dropdown-user .fa-angle-down {
    margin-top: -3px;
  }
</style>



// WEBPACK FOOTER //
// Header.vue?2921e80a